import { apiRequest } from '../api/http'
import type { TeamInvitation, TeamInviteRequest, TeamResponse } from './types'

const TEAM_BASE = '/api/team'

export function getTeam(accessToken: string): Promise<TeamResponse> {
  return apiRequest<TeamResponse>(TEAM_BASE, '', { accessToken })
}

export function inviteTeamMember(accessToken: string, body: TeamInviteRequest): Promise<TeamInvitation> {
  return apiRequest<TeamInvitation>(TEAM_BASE, '/invitations', {
    method: 'POST',
    accessToken,
    body,
  })
}

export function removeTeamMember(accessToken: string, userId: number): Promise<void> {
  return apiRequest<void>(TEAM_BASE, `/members/${userId}`, {
    method: 'DELETE',
    accessToken,
  })
}

export function cancelTeamInvitation(accessToken: string, invitationId: number): Promise<void> {
  return apiRequest<void>(TEAM_BASE, `/invitations/${invitationId}`, {
    method: 'DELETE',
    accessToken,
  })
}
